import { getClassNames } from '@websolutespa/bom-core';
import { CanvasOffscreenProvider, useLlm } from '@websolutespa/bom-mixer-llm';
import { forwardRef } from 'react';
import '../../../scss/style.scss';
import style from './page-root.module.scss';

export type PageRootProps = {
  mode: string;
  opened?: boolean;
  embedded?: boolean;
  customIntro?: boolean;
};

export const PageRoot = forwardRef<HTMLDivElement, PageRootProps>(
  function PageRoot({
    opened,
    embedded,
    customIntro,
    mode,
  }, ref) {
    const {
      Font,
      PageMain,
    } = useLlm(state => state.components);

    const classNames = getClassNames(style.root, 'llm', {
      '-open': opened,
      '-embedded': embedded,
      '-custom-intro': customIntro,
      ['-' + mode]: true,
    });

    return (
      <section
        ref={ref}
        className={classNames}
        data-opened={opened}
        data-embedded={embedded}
        data-custom-intro={customIntro}
        data-mode={mode}
      >
        <CanvasOffscreenProvider>
          <Font />
          <PageMain key="main" />
        </CanvasOffscreenProvider>
      </section>
    );
  }
);
